(() => {
  'use-strict';

  const body = document.querySelector('body');

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const clickOutsideHandle = (event) => {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.parentNode) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        // eslint-disable-next-line no-use-before-define
        toggleState(false);
      };

      const toggleState = (state) => {
        element.setAttribute('aria-expanded', state);
        element.target.setAttribute('aria-expanded', state);
        body.classList.toggle('-mainMenuIsExpanded', state);
        element.target.classList.add('-isAnimated');
        const removeAnimatedClass = () => {
          element.target.classList.remove('-isAnimated');
          element.target.addEventListener('animationend', removeAnimatedClass);
        };
        element.target.addEventListener('animationend', removeAnimatedClass);

        if (state) { // open
          document.addEventListener('click', clickOutsideHandle);
        } else { // close
          document.removeEventListener('click', clickOutsideHandle);
        }
      };

      element.target = document.getElementById(element.getAttribute('aria-controls'));

      element.addEventListener('click', () => {
        toggleState(!(element.target.getAttribute('aria-expanded') === 'true'));
      });
    });
  }

  Drupal.behaviors.burgerMenu = {
    attach: () => {
      const elements = document.querySelectorAll('.js-burger-menu');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
